export enum BlocksPaymentMethod {
  CreditCard = 'PAY_BY_CARD',
  BankTransfer = 'BANK_TRANSFER',
  DirectDebit = 'DIRECT_DEBIT',
  LeanOpenFinance = 'LEAN_OPEN_FINANCE',
}

export interface PayrailsConfigResponse {
  version: string;
  data: string;
  paymentId: string;
}

